// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';

export const patchTimesheetProposalEntryPathParamsSchema = z.object({
  account_id: z.number().int().describe("Account ID"),
  entry_id: z.coerce.string().describe("Proposal entry ID"),
});

export const patchTimesheetProposalEntryHeaderParamsSchema = z.object({
  Authorization: z.coerce.string().describe("OAuth 2.0 Bearer token"),
});

/**
 * @description Entry patched successfully
 */
export const patchTimesheetProposalEntry200Schema = z.object({
  timely_project_id: z.optional(z.number().int()),
  timely_label_ids: z.optional(z.array(z.number().int())),
  note: z.coerce.string().nullish(),
  duration_minutes: z.number().int().nullish(),
  hour_id: z.number().int().nullish(),
  resource_id: z.coerce.string().describe("The work item this entry proposes: either a TIC resource uuid or a native linked work item uri (\"timely://work-items/<id>\").").nullish(),
  started_at: z.coerce.string().nullish(),
  ended_at: z.coerce.string().nullish(),
  updated_at: z.coerce.string().nullish(),
});

/**
 * @description Entry not found
 */
export const patchTimesheetProposalEntry404Schema = z.object({
  message: z.coerce.string(),
});

export const patchTimesheetProposalEntryMutationRequestSchema = z.object({
  timely_project_id: z.optional(z.number().int()),
  timely_label_ids: z.optional(z.array(z.number().int())),
  note: z.coerce.string().nullish(),
  duration_minutes: z.number().int().nullish(),
  hour_id: z.number().int().nullish(),
  resource_id: z.coerce.string().describe("The work item this entry proposes: either a TIC resource uuid or a native linked work item uri (\"timely://work-items/<id>\").").nullish(),
  started_at: z.coerce.string().nullish(),
  ended_at: z.coerce.string().nullish(),
});

export const patchTimesheetProposalEntryMutationResponseSchema = z.lazy(() => patchTimesheetProposalEntry200Schema);
